import { Spin } from 'antd';
import styled from 'styled-components';

const Spinner = styled(Spin)`
  .ant-spin-dot-item {
    background-color: ${p => p.theme.orange};
  }
`;

export default Spinner;
